module.exports = __webpack_public_path__ + "static/media/add-document.caa5ae10.svg";